import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-bgDark h-screen flex flex-col" }
const _hoisted_2 = { class: "relative overflow-hidden flex flex-grow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_TimeList = _resolveComponent("TimeList")!
  const _component_Timer = _resolveComponent("Timer")!
  const _component_BottomNav = _resolveComponent("BottomNav")!
  const _component_CreateSessionModal = _resolveComponent("CreateSessionModal")!
  const _component_SolveDetails = _resolveComponent("SolveDetails")!
  const _component_SessionDeleteModal = _resolveComponent("SessionDeleteModal")!
  const _component_LoginModal = _resolveComponent("LoginModal")!
  const _component_RegisterModal = _resolveComponent("RegisterModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TimeList, { toggles: _ctx.toggleTList }, null, 8, ["toggles"]),
      _createVNode(_component_Timer)
    ]),
    _createVNode(_component_BottomNav, { onToggleTimeList: _ctx.toggleTimeList }, null, 8, ["onToggleTimeList"]),
    _createVNode(_component_CreateSessionModal),
    _createVNode(_component_SolveDetails),
    _createVNode(_component_SessionDeleteModal),
    _createVNode(_component_LoginModal),
    _createVNode(_component_RegisterModal)
  ]))
}